var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.stats,"show-empty":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }